<template>
  <form
    accept-charset="utf-8"
    action="/"
    enctype="application/x-www-form-urlencoded"
    id="login"
    method="post"
    role="form"
  >
    <div class="bg-white border-secondary shadow-sm rounded p-3 h-100 mt-2 mb-5">
      <div class="text-step">
        <h5>
          <span class="badge badge-pill badge-warning mr-3">STEP 4</span>
          <span class="title pt-2 mt-2">สร้างบัญชีสำเร็จ</span>
        </h5>
      </div>
      <div class="mt-3">
        <b-row class="mb-3">
          <b-col cols="12 text-center text-success">
            <i class="far fa-check-circle fa-6x"></i>
            <h4 class="mt-3">สมัครสมาชิกเรียบร้อย</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-card
              class="member-card"
              header-tag="header"
              header-bg-variant="default"
              body-bg-variant="white"
              border-variant="warning"
              header-text-variant="warning"
              footer-bg-variant="warning"
              footer-tag="footer"
            >
              <template #header>
                <h5 class="mb-0 text-center">ข้อมูลสมาชิกของท่าน</h5>
              </template>

              <b-row class="d-flex justify-content-center mb-4">
                <b-col cols="12" sm="8" md="5" lg="4" class="align-self-center">
                  <b-row>
                    <b-col cols="4">
                      <b-badge variant="dark" class="w-100">ชื่อผู้ใช้</b-badge>
                    </b-col>
                    <b-col cols="8">
                      <b-badge variant="secondary" class="w-100">{{username}}</b-badge>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="4">
                      <b-badge variant="dark" class="w-100">รหัสผ่าน</b-badge>
                    </b-col>
                    <b-col cols="8">
                      <b-badge variant="secondary" class="w-100">{{password}}</b-badge>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="text-center font-weight-bold mb-2">Ref: 1234</b-col>
                <b-col cols="12" class="text-center">กรุณาจดข้อมูลไว้เพื่อใช้เข้าเล่นครั้งต่อไป</b-col>
                <b-col cols="12" class="text-center">ช่องทางการเข้าเล่น {{getSiteName}}</b-col>
              </b-row>

              <template #footer>
                <div class="text-center">กรุณาเก็บข้อมูลของท่าน เพื่อใช้ในการเข้าเล่นครั้งต่อไป</div>
              </template>
            </b-card>
          </b-col>
          <b-col cols="12" class="mt-3">
            <b-alert variant="secondary" show class="text-center">
              ขั้นตอนต่อไป
              <strong>เพิ่มบัญชีธนาคาร</strong> เพื่อทำการ
              <strong>ลงทะเบียน</strong> ให้สมบูรณ์
            </b-alert>
          </b-col>
        </b-row>
      </div>
      <div class="mt-2">
        <div class="bg-secondary border-dark shadow-sm p-3 mt-2 mb-0 fixed-bottom">
          <div class="row">
            <div class="col">
              <button type="button" class="btn golden-btn btn-block" @click="register()">
                <i class="fas fa-plus"></i> เพิ่มบัญชีธนาคาร&nbsp;&nbsp;&nbsp;
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

export default {
  name: "RegisterStep4",
  props: ['username', 'password'],
  data() {
    return {};
  },
  methods: {
    register() {
      this.$router.push("/member/settings/bank");
    }
  },
  computed: {
    ...mapGetters({
      getSiteName: "getSiteName"
    })
  }
};
</script>

<style lang="scss" scoped>
.member-card {
  h5 {
    font-family: SukhumvitBold;
  }
}

.code-input {
  border-color: #bd841b !important;
  width: 40px;
  padding: 0;
  margin: 10px 10px;
  font-size: 25px;
  line-height: 40px;
  height: 40px;
  font-family: SukhumvitBold;
  color: #bd841b !important;
}

form {
  label {
    font-family: SukhumvitBold;
  }
}

.code-ref {
  font-size: 20px;
  letter-spacing: 5px;
}

.numpad {
  .btn {
    font-family: SukhumvitBold;
  }

  .btn-reset-form {
    font-size: 100%;
    line-height: 1.5;
    height: 48px;
  }

  .golden-btn-numpad {
    display: inline-block;
    outline: none;
    /* font-family: inherit; */
    font-family: SukhumvitBold;
    box-sizing: border-box;
    border: none;
    border-radius: 0.2em;
    text-transform: uppercase;
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(110 80 20 / 40%),
      inset 0 -1px 2px 1px rgb(139 66 8), inset 0 -1px 1px 2px rgb(250 227 133);
    background-image: linear-gradient(
      160deg,
      #a54e07,
      #b47e11,
      #fef1a2,
      #bc881b,
      #a54e07
    );
    border: 1px solid #a55d07;
    color: rgb(120, 50, 5);
    text-shadow: 0 2px 2px rgb(250 227 133);
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    background-size: 100% 100%;
    background-position: center;
  }
}

.golden-btn {
  display: inline-block;
  outline: none;
  /* font-family: inherit; */
  font-family: SukhumvitBold;
  font-size: 1em;
  box-sizing: border-box;
  border: none;
  border-radius: 0.2em;
  height: auto;
  line-height: 1.9em;
  text-transform: uppercase;
  padding: 3px 0;
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(110 80 20 / 40%),
    inset 0 -1px 2px 1px rgb(139 66 8), inset 0 -1px 1px 2px rgb(250 227 133);
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  );
  border: 1px solid #a55d07;
  color: rgb(120, 50, 5);
  text-shadow: 0 2px 2px rgb(250 227 133);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-size: 100% 100%;
  background-position: center;
}

.text-step {
  font-family: SukhumvitBold;

  .title {
    color: rgb(189, 132, 41) !important;
  }
}

.indexlogo {
  width: 100%;
}

.goldpattern {
  background-size: 100%;
  background: url(../../assets/images/gold-pattern.jpg) top center;
}

.select-btn {
  color: #b47e18 !important;
  background-color: white !important;
  background-image: none;
  border-color: #bd841b !important;
  word-wrap: break-word;
  overflow: hidden;
  display: block;
  font-family: Sukhumvit;
}

.select-btn:hover {
  color: white !important;
  background-color: #bd841b !important;
  background-image: none;
  border-color: #bd841b !important;
}
</style>